import React from 'react'
import { StyleSheet, View } from 'react-native'
import { NoBanking } from './NoBanking'
import { colors, hexToRgba } from '../../functions'

const s = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  navbarContainer: {
    marginTop: -44,
    height: 44,
    alignSelf: 'stretch',
    backgroundColor: hexToRgba(colors.primary2, 0.1),
    flexDirection: 'row',
    justifyContent: 'center',
  },
})

class Banking extends React.Component {
  state = {
    showTabs: true,
  }
  render() {
    return (
      <React.Fragment>
        <View style={s.navbarContainer} />
        <View style={s.wrapper}>
          <NoBanking />
        </View>
      </React.Fragment>
    )
  }
}

export default Banking
